/**
 * Floating WhatsApp button: out of the way while the shopper reads.
 *
 * Scrolling down (past the first screen) sets `body[data-wa-away]`, so the
 * button slides off instead of covering cards, option buttons and text;
 * scrolling up, or reaching the top, brings it back (the pattern of mobile
 * headers and of Noon / Shein chat buttons). Works with both scroll
 * containers Horizon uses: the window on phones, `.page-wrapper` from 990px.
 *
 * Styles: assets/custom-theme.css ("Floating WhatsApp button"). The product
 * page's own tuck rule (`data-wa-tucked`, assets/custom-product.js) is
 * independent and still applies.
 */
const THRESHOLD = 480; // px from the top before the button may hide
const DELTA = 6; // ignore jitter

let last = 0;
let ticking = false;

/** @param {EventTarget | null} target */
function positionOf(target) {
  if (target instanceof HTMLElement && target.classList.contains('page-wrapper')) return target.scrollTop;
  return window.scrollY || document.documentElement.scrollTop;
}

/** @param {Event} event */
function onScroll(event) {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    ticking = false;
    const y = positionOf(event.target);
    if (Math.abs(y - last) < DELTA) return;
    const away = y > last && y > THRESHOLD;
    document.body.toggleAttribute('data-wa-away', away);
    last = y;
  });
}

if (document.querySelector('.whatsapp-float')) {
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
}
